<!-- Shows the sidenav with condition-->
<div class="d-flex" style="height: 100vh;overflow: hidden;">
    <app-default-layout *ngIf="showSidenav()"></app-default-layout>
    <div style="overflow-y: auto;" [ngStyle]="{ 'width': showSidenav()? 'calc(100vw - 250px)': '100vw'}">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- To show the response message and loader for whole application-->
<app-loader-pop></app-loader-pop>
<app-message-pop></app-message-pop>